import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-accordion/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-alert-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-avatar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-checkbox/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-collapsible/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-context-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-dialog/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-form/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-hover-card/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-label/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-menubar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-navigation-menu/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-one-time-password-field/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-password-toggle-field/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-popover/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-portal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-progress/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-radio-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-scroll-area/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-select/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-switch/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-tabs/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toggle-group/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toggle/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-toolbar/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@radix-ui/react-tooltip/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["CarouselBlock"] */ "/app/src/lib/payload/Carousel/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageWithCaption"] */ "/app/src/lib/payload/Image/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QrLinksBlock"] */ "/app/src/lib/payload/QrLinks/Component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/lib/payload/Video/VideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoListBlock"] */ "/app/src/lib/payload/VideoList/Component.tsx");
